module.exports = __webpack_public_path__ + "media/directory/opento_icon-a5df92b5.svg";